export const REQUEST_ARTICLE_LIST = 'REQUEST_ARTICLE_LIST';
export const RECEIVE_ARTICLE_LIST = 'RECEIVE_ARTICLE_LIST';
export const RECEIVE_ARTICLE_LIST_ERROR = 'RECEIVE_ARTICLE_LIST_ERROR';

export const REQUEST_TOPIC_TREE = 'REQUEST_HOME_TOPIC_TREE';
export const RESPONSE_TOPIC_TREE = 'RESPONSE_HOME_TOPIC_TREE';
export const ERROR_TOPIC_TREE = 'ERROR_HOME_TOPIC_TREE';

export const REQUEST_POPULAR_LIST = 'REQUEST_POPULAR_LIST';
export const RECEIVE_POPULAR_LIST = 'RECEIVE_POPULAR_LIST';
export const RECEIVE_POPULAR_ERROR = 'RECEIVE_POPULAR_ERROR';
export const RECEIVED_POPULAR_LIST_NAA = 'RECEIVED_POPULAR_LIST_NAA';

export const REQUEST_COMMUNITY_RESULTS = 'REQUEST_COMMUNITY_RESULTS';
export const RECEIVE_COMMUNITY_RESULTS = 'RECEIVE_COMMUNITY_RESULTS';
export const RECEIVE_COMMUNITY_ERROR = 'RECEIVE_COMMUNITY_ERROR';

export const UPDATE_BREADCRUMB = 'UPDATE_BREADCRUMB';

export const TOGGLE_RELATED = 'TOGGLE_RELATED';

export const RELATED_TOGGLE_RESET = 'RELATED_TOGGLE_RESET';
export const RESET_BREADCRUMB = 'RESET_BREADCRUMB';

export const REQUEST_OPEN_CASE = 'REQUEST_OPEN_CASE';
export const RECEIVE_OPEN_CASE = 'RECEIVE_OPEN_CASE';
export const RECEIVE_OPEN_CASE_ERROR = 'RECEIVE_OPEN_CASE_ERROR';
export const SET_CHAT_BOT_LOADED = 'SET_CHAT_BOT_LOADED';
export const SET_CHAT_BOT_ERROR = 'SET_CHAT_BOT_ERROR';

// Machine Translation Article Request
export const REQUEST_MACHINE_ARTICLE = 'REQUEST_MACHINE_ARTICLE';
export const RECEIVE_MACHINE_ARTICLE_RESPONSE = 'RECEIVE_MACHINE_ARTICLE_RESPONSE';
export const RECEIVE_MACHINE_ARTICLE_ERROR = 'RECEIVE_MACHINE_ARTICLE_ERROR';

export const BNA_PROMPT_REQUEST = 'BNA_PROMPT_REQUEST';

export const CHATBOT_FAQ_DISPLAY_CHECKER = 'CHATBOT_FAQ_DISPLAY_CHECKER';

// For Displaying top contact Reasons
export const REQUEST_TOP_CONTACT_REASONS = 'REQUEST_TOP_CONTACT_REASONS';
export const DEFAULT_TOP_SEARCH_REASON = 'DEFAULT_TOP_SEARCH_REASON';
export const DEFAULT_TOP_SEARCH_REASON_ERROR = 'DEFAULT_TOP_SEARCH_REASON_ERROR';
export const SHOW_TOP_CONTACT_REASON = 'SHOW_TOP_CONTACT_REASON';
export const HIDE_TOP_CONTACT_REASON = 'HIDE_TOP_CONTACT_REASON';
export const SEARCHBAR_INPUTBOX_FOCUS = 'SEARCHBAR_INPUTBOX_FOCUS';
export const COMPLAINTS_PAGE_COMMON_QUESTIONS = 'COMPLAINTS_PAGE_COMMON_QUESTIONS';
// APP Experiments
export const ELMO_EXPERIMENTS_REQUESTED = 'ELMO_EXPERIMENTS_REQUESTED';
export const ELMO_EXPERIMENTS_RECEIVED = 'ELMO_EXPERIMENTS_RECEIVED';
export const ELMO_EXPERIMENTS_ERROR = 'ELMO_EXPERIMENTS_ERROR';

// get default auto-complete suggestion with the first BNA article detail
export const REQUEST_DEFAULT_PCC_ARTICLES = 'REQUEST_DEFAULT_PCC_ARTICLES';
export const RECEIVED_DEFAULT_PCC_ARTICLES = 'RECEIVED_DEFAULT_PCC_ARTICLES';
export const RECEIVED_DEFAULT_PCC_ARTICLES_ERROR = 'RECEIVED_DEFAULT_PCC_ARTICLES_ERROR';

// Auth Prompt in the HCR for validating on-call users
export const INIT_AUTH_CALL = 'INIT_AUTH_CALL';
export const CONFIRM_AUTH_CALL = 'CONFIRM_AUTH_CALL';
export const REJECT_AUTH_CALL = 'REJECT_AUTH_CALL';
export const CLOSE_AUTH_CALL = 'CLOSE_AUTH_CALL';
export const SENDING_CONFIRM = 'SENDING_CONFIRM';
export const AUTH_FAILED = 'AUTH_FAILED';

// ICF Contents
export const REQUEST_ICF_CONTENTS = 'REQUEST_ICF_CONTENTS';
export const RECEIVED_ICF_CONTENTS = 'RECEIVED_ICF_CONTENTS';
export const RECEIVED_ICF_CONTENTS_ERROR = 'RECEIVED_ICF_CONTENTS_ERROR';
export const ICF_SELECTED = 'ICF_SELECTED';
export const EXPAND_FAQ_CONTENT = 'EXPAND_FAQ_CONTENT';
export const UPDATE_VISITED_ACCESS_LIST = 'UPDATE_VISITED_ACCESS_LIST';
export const REQUEST_SET_ICF_ACCESSED_ARTICLE = 'REQUEST_SET_ICF_ACCESSED_ARTICLE';
export const RECEIVED_SET_ICF_ACCESSED_ARTICLE = 'RECEIVED_SET_ICF_ACCESSED_ARTICLE';
export const RECEIVED_SET_ICF_ACCESSED_ARTICLE_ERROR = 'RECEIVED_SET_ICF_ACCESSED_ARTICLE_ERROR';
export const REQUEST_GET_ICF_ACCESSED_ARTICLE = 'REQUEST_GET_ICF_ACCESSED_ARTICLE';
export const RECEIVED_GET_ICF_ACCESSED_ARTICLE_ERROR = 'RECEIVED_GET_ICF_ACCESSED_ARTICLE_ERROR';
export const ICF_PROMPT_CONFIG_CHECKER = 'ICF_PROMPT_CONFIG_CHECKER';
export const ICF_CONFIG_CHECKER = 'ICF_CONFIG_CHECKER';

// ALL ICF GUIDES
export const REQUEST_ICF_GUIDES = 'REQUEST_ICF_GUIDES';
export const RECEIVE_ICF_GUIDES_RESPONSE = 'RECEIVE_ICF_GUIDES_RESPONSE';
export const RECEIVE_ICF_GUIDES_ERROR = 'RECEIVE_ICF_GUIDES_ERROR';
export const REQUEST_ARTICLE_ICF_CONTENTS = 'REQUEST_ARTICLE_ICF_CONTENTS';
export const RECEIVED_ARTICLE_ICF_CONTENTS = 'RECEIVED_ARTICLE_ICF_CONTENTS';
export const RECEIVED_ARTICLE_ICF_CONTENTS_ERROR = 'RECEIVED_ARTICLE_ICF_CONTENTS_ERROR';

export const GUIDE_CLICKED = 'GUIDE_CLICKED';

// Dispute tracker actions
export const REQUEST_OPEN_DISPUTE = 'REQUEST_OPEN_DISPUTE';
export const RECEIVE_OPEN_DISPUTE = 'RECEIVE_OPEN_DISPUTE';
export const RECEIVE_OPEN_DISPUTE_ERROR = 'RECEIVE_OPEN_DISPUTE_ERROR';

// Update context elmo
export const RESET_OMNI_CHANNEL_PROMPT_INFO = 'RESET_OMNI_CHANNEL_PROMPT_INFO';
export const UPDATE_CONTEXT_ELMO_INTENT = 'UPDATE_CONTEXT_ELMO_INTENT';
export const RESET_UPDATE_CONTEXT_ELMO_INTENT = 'RESET_UPDATE_CONTEXT_ELMO_INTENT';

// For enabling L3 Topics
export const UPDATE_L2_TOPICS = 'UPDATE_L2_TOPICS';
export const UPDATE_TOPIC_LEVEL = 'UPDATE_TOPIC_LEVEL';
export const L3_TOPIC_CLICKED = 'L3_TOPIC_CLICKED';

export const UPDATE_L1_TOPIC_DETAILS = 'UPDATE_L1_TOPIC_DETAILS';
export const UPDATE_L2_SELECTED_TOPIC = 'UPDATE_L2_SELECTED_TOPIC';
export const UPDATE_L2_TOPIC_DETAILS = 'UPDATE_L2_TOPIC_DETAILS';
export const UPDATE_L3_SELECTED_TOPIC = 'UPDATE_L3_SELECTED_TOPIC';
export const UPDATE_L3_SELECTED_TOPIC_DETAILS = 'UPDATE_L3_SELECTED_TOPIC_DETAILS';
export const UPDATE_TOPIC_DETAILS = 'UPDATE_TOPIC_DETAILS';
export const UPDATE_SELECTED_ARTICLE = 'UPDATE_SELECTED_ARTICLE';
export const RESET_TOPIC_DETAILS = 'RESET_TOPIC_DETAILS';
